module.exports = __webpack_public_path__ + "static/diptheria-3a1d51f12cf040bb23fb31507fb234c3.png";